import React from 'react'

export const VerticalSeparator = () => <div className="et-vertical-separator" />
